import { batchStatus } from '@transfeeradev/api-enums';

export default {
  [batchStatus.DRAFT]: 'ic-lock-open',
  [batchStatus.WAITING_APPROVAL]: 'ic-stamp',
  [batchStatus.WAITING]: 'ic-access-time',
  [batchStatus.FINISHED]: 'ic-done-all',
  [batchStatus.RECEIVED]: 'ic-done'
};
